import { Button } from "ui/button";
import toast, { Toast } from "components/partials/toast/toast";

type EmailWriterCompletionToastData = {
  title: string;
  message?: string;
  actionLabel?: string;
  destinationPath?: string;
  autoClose?: boolean;
  onNavigate?: (path: string) => void;
};

export const showEmailWriterCompletionToast = ({
  title,
  message,
  actionLabel,
  destinationPath,
  autoClose = false,
  onNavigate,
}: EmailWriterCompletionToastData) => {
  toast.success({
    data: {
      title,
      message,
    },
    autoClose: autoClose ? 5000 : false,
    render: (props) => (
      <Toast data={props.data}>
        {actionLabel && destinationPath && onNavigate ? (
          <Button
            onClick={() => {
              onNavigate(destinationPath);
              toast.dismiss(props.toastProps.toastId);
            }}>
            {actionLabel}
          </Button>
        ) : null}
      </Toast>
    ),
  });
};
